import React, {useState, useEffect} from 'react'
import ImageLightBox from '../../third-party/ImageLightBox'
import AspectRatio from '../../atoms/AspectRatio'
import { getImages } from '../../../utils/galeryEvents'
import { Row, Col } from '../../atoms/Grid'
import Font from '../../../atoms/Font';
import Button from '../../atoms/Button'
import PlaceHolder from '../../atoms/Placeholder'


export default function GaleryImages (props) {

    const [lightBox, setLightBox] = useState(false)
    const [loading, setLoading] = useState(true)
    const [indexImageLightBox, setIndexImageLightBox] =  useState(0)  
    const [imagesList, setImagesList] = useState([])
    const [imagesListFull, setImagesListFull] = useState([])
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [haveMore, setHaveMore] = useState(false)
    const token = props.token
    const kind = props.kind
    const limit = props.limit
    
    useEffect(()=>{
        listImages(token, kind)
    }, [])

    function listImages(token, kind) {
        getImages(token, kind, imagesList.length, limit)
        .then(resp => {
            if(resp && resp.errors){
                setImagesListFull([])
                setImagesList([])
            }

            if(resp) {
                resp.result.forEach(image => {
                    imagesList.push(image.url)
                    imagesListFull.push(image.fullImage)
                })
                setImagesListFull([ ...imagesListFull ])
                setImagesList([ ...imagesList ])
                setHaveMore(resp.total > imagesList.length)
                setLoadingBtn(false)
                setLoading(false)
            }
        })
    }

    function handleLoadMore() {
        setLoadingBtn(true)
        listImages(token, kind)
    }

    function openImage(index) {
        setLightBox(true)
        setIndexImageLightBox(index)
    }

    if(loading)
        return(
            <Loading />
        )

    return (
        
        <Col size='12'>
            <Row>
                <Font size='30' weight='100' style={{width: '100%', marginBottom: '30px', marginTop: '40px'}}>Imagens do evento</Font>
                {imagesList.length <= 0 && (
                    <Font style={{marginBottom: '60px'}}>Nenhuma foto enviada ainda, envie as suas!</Font>
                )}
            </Row>
            {imagesList.length > 0 && (
                <React.Fragment>
                    <Row>        
                        {imagesList.map((image, key) => (
                            <Col key={key} size='4 3 3'>
                                <Row>
                                    <AspectRatio
                                        ratio={'1x1'}
                                        background={image}
                                        onClick={() => openImage(key)}
                                        style={{ cursor: 'pointer', border: '1px solid #fff' }}
                                    />
                                </Row>
                            </Col>
                        ))}
                    {haveMore && (
                        <Col size='12' text='center'>
                            <Button loading={loadingBtn} onClick={() => handleLoadMore()} primary inline style={{marginTop: '20px'}}>Carregar mais imagens</Button>
                        </Col>
                    )}
                    
                    </Row>


                    <ImageLightBox handleClose={() => {
                                        setLightBox(false)
                                    }} 
                                    isOpen={lightBox}
                                    images={imagesListFull}
                                    photoIndex={indexImageLightBox}
                    />
                </React.Fragment>
            )}
            </Col>

    )
}

const Loading = () => (

    <Row>
        <Col size='9 10 10' spacing={2}>
            <PlaceHolder box style={{ marginBottom: '0', height: '30px', marginTop: '40px' }} />
        </Col>
        <Col size='4 3 3' style={{paddingRight: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{padding: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{padding: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{paddingLeft: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{paddingRight: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{padding: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{padding: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{paddingLeft: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{paddingRight: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{padding: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{padding: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
        <Col size='4 3 3' style={{paddingLeft: '0', border: '1px solid #fff'}}>
            <PlaceHolder box style={{ marginBottom: '0', height: '180px'}} />
        </Col>
    </Row>

)


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/organisms/GaleryEvents/index.js